import {
    createRegisterableComponent,
    DataLayerEventName,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import { ElectionFilterContext } from '../../contexts'
import { ElectionFilter } from '../../widgets/election/components'
import { ElectionSearchInput } from '../../widgets/election/components/ElectionSearch'
import { FederalElection2025Logo } from './Logo'

//demo page component to pop components onto
export const TNFedElection2025Page = createRegisterableComponent(
    'nightly-fed-election-2025-page',
    (_, services) => {
        const { search, state, sort } = useContext(ElectionFilterContext)

        return (
            <div
                style={{
                    backgroundColor: '#F4F4F4',
                    borderRadius: '12px',
                    padding: '24px',
                    margin: '20px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        flexDirection: 'column',
                    }}
                >
                    Small
                    <FederalElection2025Logo size="small" />
                    Large
                    <FederalElection2025Logo size="large" />
                    Stacked
                    <FederalElection2025Logo size="stacked" />
                    Switch
                    <FederalElection2025Logo size="switch" />
                </div>
                <div>
                    <ElectionSearchInput
                        onEvent={services.onEvent}
                        electionFilter={search}
                    />
                    <ElectionFilter
                        headingText="Sort by"
                        dataLayerEventOriginator="ElectionSort"
                        onEvent={services.onEvent}
                        dataLayerEventName={DataLayerEventName.searchFilter}
                        electionFilter={sort}
                    />
                    <ElectionFilter
                        headingText="State"
                        dataLayerEventOriginator="ElectionStateFilter"
                        onEvent={services.onEvent}
                        dataLayerEventName={DataLayerEventName.searchFilter}
                        electionFilter={state}
                    />
                </div>
            </div>
        )
    },
)
